module.exports = __webpack_public_path__ + "static/img/22.58527ad.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/2/zh/22.png
// module id = JHdI
// module chunks = 0